import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { localPersistStorage } from "~/lib/persist-storage";
import { CalendarView } from "../components";

type Appointment = {
  id: string;
  title: string;
  description: string;
  start: Date;
  end: Date;
  location: string;
  status: string;
  patient_id: string;
  provider_id: string;
  created_at: Date;
};

type FormType = {
  appointments: Appointment[];
  setAppointments: (appointments: Appointment[]) => void;
  view: CalendarView;
  setView: (view: CalendarView) => void;
};

const initialState = {
  appointments: [] as Appointment[],
  view: "month" as CalendarView,
};

export const useAppointmentsStore = create<FormType>()(
  persist(
    (set) => ({
      ...initialState,
      setAppointments: (appointments) => set({ appointments: appointments }),
      setView: (view) => set({ view: view }),
    }),
    {
      name: "auth-storage",
      storage: createJSONStorage(() => localPersistStorage),
    },
  ),
);

